import { combineReducers } from 'redux';
import authReducers from './Auth/reducers';
import themeReducers from './Theme/reducers';

export const reducer = combineReducers({
    auth: authReducers,
    theme: themeReducers
})